/* unplugin-vue-components disabled */import script from "./DistributorDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributorDetails.vue?vue&type=script&setup=true&lang=js"

import "./DistributorDetails.vue?vue&type=style&index=0&id=3380b034&lang=scss"

const __exports__ = script;

export default __exports__